import { InfoBox, Link, Typography } from "@cappelendamm/design-system/react";
import NextLink from "next/link";
import { WarningCircle } from "iconoir-react";

export const DigitalServiceLoginRequiredInfoBox = () => {
  return (
    <InfoBox className="flex w-full items-start gap-2">
      <WarningCircle width={32} height={32} className="text-lg" />
      <Typography variant="body-sm">
        Du må{" "}
        <Link
          variant="inline"
          as={NextLink}
          href="/login"
          className="text-black"
        >
          logge inn
        </Link>{" "}
        for å kjøpe digitale læremidler.
      </Typography>
    </InfoBox>
  );
};
